import { ChangeDetectionStrategy, Component, forwardRef, OnChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationKeyPipe, SlotTooltipPipe, AddSpacePipe } from '../../../pipes';
import { ComponentsModule } from '../../../../../lib';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SlotInputComponent } from '../slot-input/slot-input.component';
import { VisualComponent } from '../../visual/visual.component';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'ca-slot-tile-optional-input',
    imports: [CommonModule, FormsModule, ComponentsModule, TranslationKeyPipe, SlotTooltipPipe, AddSpacePipe, VisualComponent, MatCheckbox],
    templateUrl: './slot-tile-optional-input.component.html',
    styleUrl: './slot-tile-optional-input.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlotTileOptionalInputComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlotTileOptionalInputComponent extends SlotInputComponent implements OnInit, OnChanges {
    checked: boolean = false;

    override ngOnInit() {
        super.ngOnInit();
        this.checked = !!this.value();
        this.control.setValue(this.value());
    }

    override writeValue(value: boolean): void {
        this.checked = !!value;
        this.value.set(value);
        this.control.setValue(this.value());
    }

    public changeValueOnToggle() {
        if (this.checked) return;
        this.value.set(null);
        this.control.setValue(null);
        this.onChange(null);
    }

    override setError() {
        const error = this.errorMessageTranslation && this.checked ? { error: this.errorMessageTranslation } : null;
        const control = this.isFormGroupNeeded ? this.formGroup : this.control;
        control.setErrors(error);
    }
}
